import { CanMatchFn } from '@angular/router';

export const localhostOnlyGuard: CanMatchFn = () => ['localhost', '127.0.0.1'].includes(window.location.hostname);
